import React, {useCallback, useEffect, useRef, useState} from 'react';
import Scrollbars from "react-custom-scrollbars-2";
import {NumericFormat} from "react-number-format";
import axios from "axios";
import useWindowDimensions from "../Wedgits/useWindowDimensions";
import toast from "react-hot-toast";

function MenuContent(props) {

    const {height, width} = useWindowDimensions();

    const [search, setSearch] = useState(null);
    const [isLoading, setIsloading] = useState(false);
    const [error, setError] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState("");
    const [moreInfoModal, setMoreModal] = useState(false);
    const [menuList, setMenuList] = useState([]);
    const [branchData, setBranchData] = useState("");
    const branchDataRef = useRef();
    const [defaultImg, setDefaultImg] = useState(null);

    let newTime = new Date().getTime();

    const fetchBranches = useCallback(async () => {
        setIsloading(true);
        setError(null);

        try {
            const Response = await axios.get(`/v1/branches`, {
                headers: {
                    Authorization: localStorage.getItem("token"),
                    "branch-code": axios.defaults.url,
                },
            });
            if (Response.status == 200) {
                setBranchData(Response.data.data.d[0]);
                branchDataRef.current = Response.data.data.d[0];
                fetchTags(Response.data.data.d[0]);
                setDefaultImg(Response.data.data.d[0].logo);
            }
        } catch (error) {
            toast.error(error.response.data.errors[0].msg);
            if ((error?.response?.status ?? 0) === 401) {
                localStorage.removeItem("token");
                // //console.log(error);
                setTimeout(() => {
                    window.location = "/";
                }, 2000);
            }
        }

        setIsloading(false);
    }, []);

    const [tagList, setTagList] = useState([]);
    const fetchTags = useCallback(async (branchData) => {
        setIsloading(true);
        setError(null);

        const loadedData = [];

        try {
            const Response = await axios.get(`/v1/meals/tags`, {
                headers: {
                    Authorization: localStorage.getItem("token"),
                    "branch-code": axios.defaults.url,
                },
            });
            if (Response.status == 200) {
                setTagList(Response.data.data.d);
                fetchMeals(Response.data.data.d[0]?.code);
            }
        } catch (error) {
            toast.error(error.response.data.errors[0].msg);
            if ((error?.response?.status ?? 0) === 401) {
                localStorage.removeItem("token");
                // //console.log(error);
                setTimeout(() => {
                    window.location = "/";
                }, 2000);
            }
        }

        setIsloading(false);
    }, []);

    const [selectedTag, setSelectedTag] = useState("");

    const fetchMeals = useCallback(async (tagCode, e) => {
        setIsloading(true);
        setError(null);

        const loadedData = [];

        try {
            const Response = await axios.get(`/v1/meals?tag_code=${tagCode}`, {
                headers: {
                    Authorization: localStorage.getItem("token"),
                    "branch-code": axios.defaults.url,
                },
            });
            if (Response.status == 200) {
                setMenuList(Response.data.data.d);
                setSelectedTag(tagCode);
                props.onSetIsFetchOver(true);
            }
        } catch (error) {
            toast.error(error.response.data.errors[0].msg);
            if ((error?.response?.status ?? 0) === 401) {
                localStorage.removeItem("token");
                // //console.log(error);
                setTimeout(() => {
                    window.location = "/";
                }, 2000);
            }
        }

        setIsloading(false);
    }, []);

    const getStatistics = useCallback(async () => {
        setIsloading(true);
        setError(null);
        let date = new Date();
        try {
            const Response = await axios.patch(
                `/v1/branches/statistics/menu_clicks`,
                {},
                {
                    headers: {
                        Authorization: localStorage.getItem("token"),
                        "branch-code": axios.defaults.url,
                    },
                }
            );
            if (Response.status == 200) {
                localStorage.setItem("statistics", date.getTime());
            }
        } catch (error) {
            toast.error(error.response.data.errors[0].msg);
            if ((error?.response?.status ?? 0) === 401) {
                localStorage.removeItem("token");
                // //console.log(error);
                setTimeout(() => {
                    window.location = "/";
                }, 2000);
            }
        }

        setIsloading(false);
    }, []);

    useEffect(() => {
        fetchBranches();
        if (!localStorage.getItem("statistics")) {
            getStatistics();
        } else {
            if ((parseInt(newTime) - parseInt(localStorage.getItem("statistics"))) > 600000) {
                getStatistics();
            }
        }
    }, []);

    return (
        <div className="menuItemsContainer">
            <Scrollbars
                autoHide
                autoHideTimeout={1000}
                style={{minHeight: height, height: "auto"}}
            >
                <div className="blankSpace"></div>
                <div className="tagContainer">
                    {tagList.map((item) => (
                        <button className={`${selectedTag == item.code ? "selected" : ""}`} onClick={() => {
                            fetchMeals(item.code)
                        }}>{item.name}</button>
                    ))}
                </div>


                {menuList.map((item, index) => (
                    <>
                        <div className={`itemCardContainer ${(index + 1) % 2 == 0 ? "odd" : ""}`}>
                            <div className="itemCard">
                                <h4 className="title">
                                    <div className="priceContainer">
                                        <NumericFormat
                                            dir={"rtl"}
                                            readOnly
                                            name="selector"
                                            className="input"
                                            placeholder="900,000"
                                            displayType="text"
                                            thousandSeparator
                                            value={item?.price}
                                        />
                                        {" "}
                                        تومان
                                    </div>
                                    <div className="nameContainer">
                                        {item?.name}
                                    </div>
                                </h4>
                                <p className="description">
                                    {item?.desc}
                                </p>
                            </div>
                            <div className="itemPhotoContainer">
                                {item?.image_name ?
                                    <img src={`${axios.defaults.baseURL}/statics/images/${item?.image_name}`}/>
                                    :
                                    <img src={`${axios.defaults.baseURL}/statics/branch_icon/${branchData.logo}`}/>
                                }
                            </div>
                        </div>

                        {/*<div className={`itemCardContainer odd`}>*/}
                        {/*    <div className="itemCard">*/}
                        {/*        <h4 className="title">*/}
                        {/*            <span>۴۲۰۰۰۰ تومان</span>*/}
                        {/*            <span>چلو کباب وزیری</span>*/}
                        {/*        </h4>*/}
                        {/*        <p className="description">۲۰۰ گرم جوجه+ ۱۵۰ گرم کوبیده + برنج ایرانی</p>*/}
                        {/*    </div>*/}
                        {/*    <div className="itemPhotoContainer">*/}
                        {/*        <img src={sample}/>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                    </>
                ))}

            </Scrollbars>
        </div>

    );
}

export default MenuContent;
